import React from "react";
import { Card, Row, Col } from "antd";
import { PhoneOutlined } from "@ant-design/icons";
import "./EmergencyContacts.css";

/**
 * EmergencyContacts
 *
 * Props:
 * - title: string (default: "Emergency Contact")
 * - contacts: array of objects:
 *   [
 *     { key: "police", label: "Police", phone: "100", color: "#b91c1c", icon: "👮‍♂️" },
 *     { key: "ambulance", label: "Ambulance", phone: "108", color: "#1e9b3a", icon: "🚑" },
 *     ...
 *   ]
 *
 * Behavior:
 * - Renders a card with a top title and centered icon.
 * - Shows each contact as a pill. Pills are responsive: 3 columns on desktop, wrap on smaller screens.
 * - If you provide more contacts, grid will lay them out automatically.
 * - Clicking the phone number triggers a tel: link.
 */
export default function EmergencyContacts({
  title = "Emergency Contact",
  contacts = [
    { key: "police", label: "Police", phone: "100", color: "#c8102e", icon: "👮‍♂️" },
    { key: "ambulance", label: "Ambulance", phone: "108", color: "#20a02b", icon: "🚑" },
    { key: "fire", label: "Fire Brigade", phone: "101", color: "#ff7a00", icon: "🔥" }
  ]
}) {
  return (
    <div id="emergency-contacts" className="emergency-section-wrapper section-padding">
      <Card className="emergency-card" bordered>
        <div className="emergency-top">
          <div className="emergency-top-badge" aria-hidden="true">
            <span className="badge-emoji">📞</span>
          </div>
          <h3 className="emergency-title">
            <span className="title-accent" aria-hidden="true" />
            {title}
          </h3>
        </div>

        <Row gutter={[16, 16]} justify="center" className="contacts-row">
          {contacts.map(contact => (
            <Col key={contact.key} xs={24} sm={12} md={8} lg={8}>
              <div
                className="contact-pill"
                style={{
                  background: contact.color ? `${contact.color}20` : "#f3f4f6", // subtle translucent bg
                  border: `1px solid ${contact.color || "#e5e7eb"}`
                }}
              >
                <div className="contact-left">
                  <div
                    className="contact-icon"
                    style={{
                      background: contact.color || "#ddd",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
                    }}
                    aria-hidden="true"
                  >
                    {/* icon space - emoji used here but you can pass React node */}
                    <span className="contact-icon-emoji">{contact.icon || "🏢"}</span>
                  </div>
                  <div className="contact-labels">
                    <div className="contact-label">{contact.label}</div>
                  </div>
                </div>

                <div className="contact-right">
                  <a className="contact-phone" href={`tel:${contact.phone}`}>
                    <PhoneOutlined className="phone-icon" />
                    <span className="phone-number">{contact.phone}</span>
                  </a>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
}